export const emptyCriterion = () => ({ type: 'attribute', attributeId: null, operator: '', values: [], productIds: [] });
export const emptyGroup = () => ({ criteriaOp: 'AND', criteria: [emptyCriterion()] });

export function parseConditions(apiCondition) {
  if (!apiCondition || !apiCondition.length) return [emptyGroup()];
  return apiCondition.map((group) => {
    const criteriaOp = group.criteria_operator || 'AND';
    const criteria = [];
    Object.keys(group).forEach((key) => {
      if (key === 'criteria_operator') return;
      const arr = group[key];
      if (!Array.isArray(arr)) return;
      arr.forEach((item) => {
        if (item.type === 'product') {
          criteria.push({ type: 'product', attributeId: null, operator: item.operator || '', values: [], productIds: (item.value || []).map((v) => (typeof v === 'number' ? v : parseInt(v, 10))) });
        } else {
          criteria.push({ type: 'attribute', attributeId: item.attribute_id != null ? item.attribute_id : null, operator: item.operator || '', values: item.value || [], productIds: [] });
        }
      });
    });
    return { criteriaOp, criteria: criteria.length ? criteria : [emptyCriterion()] };
  });
}

export function isCriterionComplete(criterion) {
  if (criterion.type === 'product') return !!criterion.operator && criterion.productIds.length > 0;
  return !!criterion.attributeId && !!criterion.operator;
}

export function collectConditions(groups, conditionOperator) {
  const condition = [];
  groups.forEach((group) => {
    const map = {};
    let idx = 1;
    group.criteria.forEach((criterion) => {
      if (criterion.type === 'product') {
        if (criterion.operator && criterion.productIds.length > 0) map[`criteria_id_${idx++}`] = [{ type: 'product', operator: criterion.operator, value: criterion.productIds }];
      } else if (criterion.attributeId && criterion.operator) {
        map[`criteria_id_${idx++}`] = [{ type: 'attribute', attribute_id: criterion.attributeId, operator: criterion.operator, value: criterion.values }];
      }
    });
    if (Object.keys(map).length) { map.criteria_operator = group.criteriaOp; condition.push(map); }
  });
  return { condition: condition.length ? condition : null, condition_operator: conditionOperator };
}
